"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FortmaticConnector = void 0;
const abstract_connector_1 = require("@web3-react/abstract-connector");
const schemas_1 = require("@dcl/schemas");
const configuration_1 = require("../configuration");
class FortmaticConnector extends abstract_connector_1.AbstractConnector {
  constructor(chainId) {
    const fortmaticConfiguration = configuration_1.getConfiguration()[schemas_1.ProviderType.FORTMATIC];
    const supportedChainIds = Object.keys(fortmaticConfiguration.apiKeys).map(key => Number(key));
    if (!supportedChainIds.includes(chainId)) {
      throw new Error("Invariant error: Unsupported chainId ".concat(chainId));
    }
    super({
      supportedChainIds
    });
    this.apiKey = fortmaticConfiguration.apiKeys[chainId];
    this.chainId = chainId;
    this.rpcUrl = fortmaticConfiguration.urls[chainId];
  }
  activate() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.fortmatic) {
        // @ts-ignore
        const {
          default: Fortmatic
        } = yield Promise.resolve().then(() => __importStar(require('fortmatic')));
        this.fortmatic = new Fortmatic(this.apiKey, {
          rpcUrl: this.rpcUrl,
          chainId: this.chainId
        });
      }
      const account = yield this.fortmatic.getProvider().enable().then(accounts => accounts[0]);
      return {
        provider: this.fortmatic.getProvider(),
        chainId: this.chainId,
        account
      };
    });
  }
  getApiKey() {
    return this.apiKey;
  }
  getProvider() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.fortmatic.getProvider();
    });
  }
  getChainId() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.chainId;
    });
  }
  getAccount() {
    return __awaiter(this, void 0, void 0, function* () {
      return this.fortmatic.getProvider().send('eth_accounts').then(accounts => accounts[0]);
    });
  }
  // tslint:disable-next-line
  deactivate() {}
  close() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.fortmatic.user.logout();
      this.emitDeactivate();
    });
  }
}
exports.FortmaticConnector = FortmaticConnector;